import { GridToolbarColumnsButton } from '@mui/x-data-grid-pro'

export function DataGridToolbarColumnsButton(props: React.ComponentProps<typeof GridToolbarColumnsButton>) {
  return <GridToolbarColumnsButton variant='text' {...props} />
}
